import { React, useEffect, useState } from "react";
import { Checkbox, Row, Col, Select, Button, message, Space } from "antd";
import "./exportTemplate.scss";
import useExportTemplateStore from "../../store/exportTemplate.store";
import ExportModal from "../exportModal";
import { all } from "axios";

function ExportTemplate() {
  const {
    exportTemplateArray,
    getAllExportTemplate,
    createExportTemplate,
    allExportTemplates,
    deleteExportTemplate,
    setCurrentExportTemplateArray,
    updateExportTemplate,
    currentExportTemplateArray,
  } = useExportTemplateStore();

  const [isEmpty, setIsEmpty] = useState(true);
  const [currentTemplateID, setCurrentTemplateID] = useState();
  const [templateName, setTemplateName] = useState("");
  const [selectedValues, setSelectedValues] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    getAllExportTemplate();
  }, []);

  useEffect(() => {
    if (allExportTemplates?.length > 0) {
      setIsEmpty(false);
    }
  }, [allExportTemplates]);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Template Updated Successfully",
    });
  };

  const onChange = (checkedValues) => {
    setSelectedValues(checkedValues);
  };

  const createTemplate = async (
    modalTemplateName,
    setOpenResponsive,
    modalSelectedValues
  ) => {
    const body = {
      UpdateType: "TEMPLATE_ADD",
      TemplateList: [
        {
          ClientName: "Accenture",
          TAName: "Pooja",
          TemplateName: modalTemplateName,
          Fields: [...modalSelectedValues, "TRACKER_HEADING_END"],
        },
      ],
    };
    await createExportTemplate(body);
    setOpenResponsive(false);
    setSelectedValues(body.TemplateList[0].Fields);
    setTemplateName(body.TemplateList[0].TemplateName);
    setIsEmpty(false);
  };

  const updateTemplate = async () => {
    const body = {
      UpdateType: "TEMPLATE_MODIFY",
      TemplateList: [
        {
          ClientName: "Accenture",
          TAName: "Pooja",
          TemplateName: templateName,
          TemplateId: currentTemplateID,
          Fields: [...selectedValues, "TRACKER_HEADING_END"],
        },
      ],
    };
    await updateExportTemplate(body);
    setSelectedValues(body.TemplateList[0].Fields);
    success();
  };

  const deleteTemplate = async () => {
    if (allExportTemplates.length === 1) {
      setIsEmpty(true);
    }
    await deleteExportTemplate(currentTemplateID);
    handleInputChange(allExportTemplates[0]?.templatename);
  };

  const handleInputChange = (value) => {
    const specificTemplate = allExportTemplates.filter(
      (template) => template.templatename === value
    );
    setTemplateName(specificTemplate[0]?.templatename);
    setCurrentTemplateID(specificTemplate[0]?.templateid);
    const newFields = specificTemplate[0]?.fields.filter(
      (ele) => ele !== "" && ele !== "TRACKER_HEADING_END"
    );
    setSelectedValues(newFields);
    setCurrentExportTemplateArray(newFields);
  };

  return (
    <>
      <div className="exportTemplate-wrapper">
        <ExportModal createTemplate={createTemplate} />
        {isEmpty ? (
          <></>
        ) : (
          <>
            <div className="company-select">
              <h6>Select a Template</h6>
              <Select
                defaultValue="Select Company"
                style={{
                  width: 200,
                }}
                onChange={handleInputChange}
                value={templateName || undefined}
                options={allExportTemplates?.map((template) => {
                  return {
                    value: template?.templatename,
                    label: template?.templatename,
                  };
                })}
              />
            </div>
            {templateName ? (
              <>
                <Checkbox.Group
                  style={{
                    width: "100%",
                  }}
                  defaultValue={exportTemplateArray}
                  value={selectedValues}
                  onChange={onChange}
                >
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Checkbox value="Date">Date</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Payroll">Payroll</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Vendor">Vendor</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Role">Role</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Candidate Name">Candidate Name</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Contact No.">Contact No.</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Email">Email</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Total Work Exp">Total Work Exp</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Current Location">
                        Current Location
                      </Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Preferred Location">
                        Preferred Location
                      </Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Highest Qualification">
                        Highest Qualification
                      </Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Current Company">
                        Current Company
                      </Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Current Designation">
                        Current Designation
                      </Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Current Salary">Current Salary</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Expected Salary">
                        Expected Salary
                      </Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Notice Period">Notice Period</Checkbox>
                    </Col>
                    <Col span={8}>
                      <Checkbox value="Status">Status</Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
                <div className="btn-wrapper">
                  {contextHolder}
                  <Button onClick={updateTemplate}>Save</Button>
                  <Button onClick={deleteTemplate}>Delete</Button>
                </div>
              </>
            ) : (
              <></>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default ExportTemplate;
